<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query'
import { useRouter } from 'vue-router'

import JobForm from '#operations/components/JobForm.vue'
import { type JobFormValues, toJobRequest } from '#operations/lib/cron-job'
import PageHeader from '#shared/components/PageHeader.vue'
import { chronosClient } from '#shared/services/api/chronos.client'

definePage({
  meta: { requiresAuth: true, title: 'New cron job' },
})

const router = useRouter()

const createJob = useMutation({
  mutationFn: (values: JobFormValues) =>
    chronosClient.POST('/api/admin/jobs', { body: toJobRequest(values) }),
  meta: { success: 'Job created.', error: 'Failed to create job.' },
})

function handleSubmit(values: JobFormValues) {
  createJob.mutate(values, { onSuccess: () => router.push('/cron') })
}

function handleCancel() {
  router.push('/cron')
}
</script>

<template>
  <PageHeader title="New job" />

  <JobForm
    :submitting="createJob.isPending.value"
    submit-label="Create"
    @submit="handleSubmit"
    @cancel="handleCancel"
  />
</template>
